import Api from "@/config/Api";

const HttpClient = Api();

export default {
  getTeamMembers(params) {
    return HttpClient.get("/me/team", { params });
  },
  getMyPermissions(params) {
    return HttpClient.get("/me/team/my-permissions", { params });
  },
  updateRole(userId, data) {
    return HttpClient.put(`/me/team/${userId}/role`, data);
  },
  updatePermissions(userId, data) {
    return HttpClient.put(`/me/team/${userId}/permissions`, data);
  },
  updateEmissionPoints(userId, data) {
    return HttpClient.put(`/me/team/${userId}/emission-points`, data);
  },
  inviteMember(data) {
    return HttpClient.post("/me/team/invite", data);
  },
  removeMember(userId, params) {
    return HttpClient.delete(`/me/team/${userId}`, { params });
  },
  getTemplates(params) {
    return HttpClient.get("/me/team/templates", { params });
  },
  createTemplate(data) {
    return HttpClient.post("/me/team/templates", data);
  },
  // ─── Multi-usuario: catálogo, invitaciones por email y puntos de emisión ───
  getCatalog(params) {
    return HttpClient.get("/me/team/catalog", { params });
  },
  getInvitations(params) {
    return HttpClient.get("/me/team/invitations", { params });
  },
  resendInvitation(invitationId) {
    return HttpClient.post(`/me/team/invitations/${invitationId}/resend`);
  },
  cancelInvitation(invitationId) {
    return HttpClient.delete(`/me/team/invitations/${invitationId}`);
  },
  acceptInvitation(data) {
    return HttpClient.post("/me/team/accept-invitation", data);
  },
  getInvitationPreview(token) {
    return HttpClient.get(`/team/invitations/${token}`);
  },
  getEmissionPoints() {
    return HttpClient.get("/me/emission-point");
  }
};
